export default "__VITE_ASSET__B$akMZeh__"